export default "__VITE_ASSET__DMO2hbnC__"